export const redirect = (tr, prosemirror) => prosemirror.dispatch.toRouter(tr.to);
